'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = exports.Wrapper = exports.IllustrationContainer = exports.Container = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = exports.Container = _styledComponents2.default.div.withConfig({
  displayName: 'CustomSidebarstyles__Container'
})(['display:flex;flex-flow:column nowrap;align-items:center;text-align:center;width:100%;']);

var IllustrationContainer = exports.IllustrationContainer = _styledComponents2.default.div.withConfig({
  displayName: 'CustomSidebarstyles__IllustrationContainer'
})(['margin:0 auto 40px;padding:0 15%;align-self:center;width:100%;']);

var Wrapper = exports.Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'CustomSidebarstyles__Wrapper'
})(['flex:1;max-width:350px;margin:0 auto 0 auto;']);

var Image = exports.Image = (0, _styledComponents2.default)(_UIImage2.default).withConfig({
  displayName: 'CustomSidebarstyles__Image'
})(['text-align:center;margin-top:20px;max-width:100%;min-height:1px;']);